import { fetchWithAuth } from "../utils/apiUtils";

export default class DeviceService {
    private static devicePath = 'asset/sites';

    constructor() { }

    public static async getDevices(siteId: string) {
        return await fetchWithAuth(`${this.devicePath}/${siteId}/devices`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async getDevice(siteId: string, deviceId: string) {
        return await fetchWithAuth(`${this.devicePath}/${siteId}/devices/${deviceId}`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async updateDevice(siteId: string, deviceId: string, data: any) {
        return await fetchWithAuth(`${this.devicePath}/${siteId}/devices/${deviceId}`, {
            method: 'PATCH',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    public static async getDeviceData(deviceId: string) {
        const endDate = new Date().toISOString().split('T')[0];
        return await fetchWithAuth('asset/device-data', {
            method: 'POST',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify({
                deviceId,
                // endDate
            })
        });
    }

    public static async getTelematicDeviceData(deviceId: string) {
        const endDate = new Date().toISOString().split('T')[0];
        return await fetchWithAuth('asset/telematic-data', {
            method: 'POST',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify({
                deviceId,
                // endDate
            })
        });
    }

    public static async getDeviceDataById(deviceId: string, deviceDataId: string) {
        return await fetchWithAuth(`asset/devices/${deviceId}/device-data/${deviceDataId}`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async getTelematicFaultDataById(faultDataId: string) {
        return await fetchWithAuth(`asset/telematic-data/${faultDataId}`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async downloadDeviceDataCsv(deviceId: string) {
        return await fetchWithAuth(`asset/devices/${deviceId}/csv`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async deleteDevice(siteId: string, deviceId: string) {
        return await fetchWithAuth(`asset/sites/${siteId}/devices/${deviceId}`, {
            method: 'DELETE',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async getLatestDeviceData(deviceId: string) {
        return await fetchWithAuth(`asset/devices/${deviceId}/data/latest`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            },
            cache: 'no-store'
        });
    }
}